import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { fetchExternalGroupRelationsAction } from '../actions';

class Pagination extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasPrevPage: null,
      hasNextPage: null
    };
  }

  hasNextPage() {
    return this.state.hasNextPage !== null || this.props.hasNextPage;
  }

  hasPrevPage() {
    return this.state.hasPrevPage !== null || this.props.hasPrevPage;
  }

  nextPage() {
    const payload = {
      external_group_ids: this.props.searchValue,
      legacy_group_ids:   this.props.legacyGroupIdsSearch,
      after:              this.props.endCursor,
      before:             null
    };
    this.props.fetchExternalGroupRelationsAction(payload);
    this.setState({ hasPrevPage: true, hasNextPage: null });
  }

  prevPage() {
    const payload = {
      external_group_ids: this.props.searchValue,
      legacy_group_ids:   this.props.legacyGroupIdsSearch,
      after:              null,
      before:             this.props.startCursor
    };
    this.props.fetchExternalGroupRelationsAction(payload);
    this.setState({ hasNextPage: true, hasPrevPage: null });
  }

  render() {
    return (
      <div className="pagination">
        <button
          disabled={!this.hasPrevPage()}
          // disabled={!this.state.hasPrevPage}
          className={`previous_page ${!this.hasPrevPage() ? 'disabled' : ''}`}
          onClick={() => this.prevPage()}
        >
          Previous
        </button>
        <button
          disabled={!this.hasNextPage()}
          // disabled={!this.state.hasNextPage}
          className={`next_page ${!this.hasNextPage() ? 'disabled' : ''}`}
          onClick={() => this.nextPage()}
        >
          Next
        </button>
      </div>
    );
  }
}

Pagination.propTypes = {
  hasPrevPage:                       PropTypes.bool,
  hasNextPage:                       PropTypes.bool,
  startCursor:                       PropTypes.string,
  endCursor:                         PropTypes.string,
  searchValue:                       PropTypes.string,
  legacyGroupIdsSearch:              PropTypes.string,
  fetchExternalGroupRelationsAction: PropTypes.func
};

const mapStateToProps = state => ({
  hasPrevPage:          state.egrReducer.hasPrevPage,
  hasNextPage:          state.egrReducer.hasNextPage,
  startCursor:          state.egrReducer.startCursor,
  endCursor:            state.egrReducer.endCursor,
  searchValue:          state.egrReducer.searchValue,
  legacyGroupIdsSearch: state.egrReducer.legacyGroupIdsSearch
});

const mapDispatchToProps = { fetchExternalGroupRelationsAction };

export default connect(mapStateToProps, mapDispatchToProps)(Pagination);
